import { render, staticRenderFns } from "./Minting.vue?vue&type=template&id=1165df10"
import script from "./Minting.vue?vue&type=script&lang=js"
export * from "./Minting.vue?vue&type=script&lang=js"
import style1 from "./Minting.vue?vue&type=style&index=1&id=1165df10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports